import { ProfileUserResponse, PublicCollectionResponse } from "@authory-packages/core";
import { UserCoverStyle, Collection, UserResponse } from "@authory-packages/core";

export const getCoverInfo = (item: UserResponse | ProfileUserResponse | Collection | PublicCollectionResponse | undefined) => {
    if (!item) return { color: undefined, authorUploadedImage: false };

    const color = item.coverStyle === UserCoverStyle.color && item.coverColor !== "" ? item.coverColor || undefined : undefined;
    const authorUploadedImage = (!color && item.coverStyle === UserCoverStyle.image) || item.coverStyle === UserCoverStyle.unsplash;

    return { color, authorUploadedImage };
};
